import devConfig from './environments/config.development';
export async function getStaticAppSettings() {
    let appEnvs = { ...devConfig }; // Default to development
    try {
        const host = window.location.protocol + '//' + window.location.host;
        const response = await fetch(`${host}/settings/env.json`);
        if (response.status !== 404) {
            appEnvs = (await response.json()) ?? appEnvs;
        }
    }
    catch (error) {
        console.error('Failed to parse JSON:', error);
    }
    finally {
        window.APP_SETTINGS = { ...(window.APP_SETTINGS ?? {}), ...appEnvs };
        window.IL_PORTAL_ENV = { name: appEnvs.ENV };
    }
}
